import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import PlusSvg from "../assets/svg/plusSvg";
import MinusSvg from "../assets/svg/minusSvg";
import { useSelector } from "react-redux";

// Reusable FilterGroup component
const FilterGroup = ({ title, items, isCondition, handleFilterChange, selected }) => {
  const [showAll, setShowAll] = useState(false);

  const visibleItems = showAll ? items : items.slice(0, 5);

  return (
    <div className="mb-3">
      <span>
        <b>{title}</b>
      </span>
      {visibleItems.map((val, i) => {
        const label = isCondition
          ? val === 1
            ? "New-Retail"
            : val === 2
              ? "New"
              : "Used"
          : val;

        return (
          <Form.Group className="mb-2" controlId={`${title}-${val}`} key={i}>
            <Form.Check
              type="checkbox"
              name={label}
              label={label}
              checked={selected.includes(val)}
              onChange={(e) =>
                handleFilterChange(title.toLowerCase(), val, e.target.checked)
              }
            />
          </Form.Group>
        );
      })}

      {items.length > 5 && (
        <Button
          className="bg-none mb-3 border-0 p-0 text-dark"
          onClick={() => setShowAll(!showAll)}
        >
          <span className="d-inline me-1">
            {showAll ? <MinusSvg /> : <PlusSvg />}
          </span>
          {showAll ? "Show Less" : "Show More"}
        </Button>
      )}
    </div>
  );
};

const FilterModal = ({ pageInitialData, setPageData , filterkey , filters , setFilters , applyFilters}) => {
  const initialFilters = useSelector((state) => state.filters);

  useEffect(() => {
    try {
      const storedFilters = JSON.parse(localStorage.getItem(filterkey));
      if (storedFilters) {
        setFilters(storedFilters);
      }
    } catch (err) {
      console.error("Failed to parse filters from localStorage:", err);
    }
  }, [filterkey]);

  useEffect(() => {
    localStorage.setItem(filterkey , JSON.stringify(filters))
  }, [filters])


  const handleFilterChange = (type, value, checked) => {
    if (!type) return;
    setFilters((prev) => {
      const updated = { ...prev, [type]: prev[type] || [] };

      if (checked) {
        if (!updated[type].includes(value)) {
          updated[type] = [...updated[type], value];
        }
      } else {
        updated[type] = updated[type].filter((v) => v !== value);
      }

      return updated;
    });
  };

  useEffect(() => {
    if (pageInitialData?.length > 0) {
      const filteredItems = applyFilters(pageInitialData, filters);
      setPageData(filteredItems);
    }
  }, [filters, pageInitialData]);

  return (
    <div className="mt-sm-5 mt-3 border mb-sm-5">
      <div className="sidebar-accordian p-3">
        <FilterGroup
          isCondition={true}
          title="Condition"
          items={initialFilters.condition}
          handleFilterChange={handleFilterChange}
          selected={filters.condition}
        />
        <FilterGroup
          title="Chipset"
          items={initialFilters.chipset}
          handleFilterChange={handleFilterChange}
          selected={filters.chipset}
        />
        <FilterGroup
          title="Brands"
          items={initialFilters.brands}
          handleFilterChange={handleFilterChange}
          selected={filters.brands}
        />
        <FilterGroup
          title="Series"
          items={initialFilters.series}
          handleFilterChange={handleFilterChange}
          selected={filters.series}
        />
        <FilterGroup
          title="Model"
          items={initialFilters.model}
          handleFilterChange={handleFilterChange}
          selected={filters.model}
        />
      </div>
    </div>
  );
};

export default FilterModal;
